/**
 * SHA-256 hex digest. Returns undefined for empty input or when
 * crypto.subtle is unavailable (insecure context, ancient browser).
 */
export async function sha256Hex(text: string): Promise<string | undefined> {
  if (!text) return undefined;
  if (typeof crypto === 'undefined' || !crypto.subtle) return undefined;
  try {
    const data = new TextEncoder().encode(text);
    const buf = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(buf))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  } catch {
    return undefined;
  }
}
